import {
  createSlice,
  createEntityAdapter,
  type EntityState,
} from "@reduxjs/toolkit";
import {
  fetchMessagesByTicketIdThunk,
  type TicketMessage,
} from "./messageListOperations";
import type { RootState } from "../../../../store/store";

// Redux Toolkit v2: EntityState now requires ID type parameter
interface MessageListState extends EntityState<TicketMessage, number> {
  isLoading: boolean;
}

const messageListAdapter = createEntityAdapter<TicketMessage>();

const slice = createSlice({
  name: "ticket-messages",
  initialState: messageListAdapter.getInitialState({
    isLoading: false,
  }) as MessageListState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMessagesByTicketIdThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMessagesByTicketIdThunk.fulfilled, (state, action) => {
      messageListAdapter.setAll(state, action.payload);
      state.isLoading = false;
    });
  },
});

const selectLoadingState = (state: RootState): boolean =>
  (state.tickets.ticketDetail as any).messages.isLoading;

const selectors = messageListAdapter.getSelectors(
  (state: RootState) => (state.tickets.ticketDetail as any).messages,
);

export const messageListSelectors = { ...selectors, selectLoadingState };

export const reducer = slice.reducer;
